// Generated by `cargo run -p echo-wire --features ts --bin gen-dto-ts`.
// DO NOT EDIT: this file is the committed TypeScript twin of
// `wire/src/dto.rs` (web-plan.md D45); CI regenerates it and fails on
// drift. 64-bit integers are emitted as `number` — they travel as
// JSON numbers and stay far under 2^53 — and every open enum is
// widened with `UnknownString`, because a server newer than this
// build may say a word it has never heard (chat-api.md §7).

/** A value a newer server may send that this build cannot name. */
export type UnknownString = string & {};

export type EntityKind = { "type": "bold" } | { "type": "italic" } | { "type": "underline" } | { "type": "strike" } | { "type": "spoiler" } | { "type": "code" } | { "type": "pre", language?: string | null, } | { "type": "blockquote", expandable?: boolean, } | { "type": "text_link", url: string, } | { "type": "url" } | { "type": "mention", user_id: number, };

export type Entity = {
/**
 * Start, in UTF-16 code units.
 */
offset: number,
/**
 * Length, in UTF-16 code units; always > 0 after [`normalize`].
 */
length: number, } & ({ "type": "bold" } | { "type": "italic" } | { "type": "underline" } | { "type": "strike" } | { "type": "spoiler" } | { "type": "code" } | { "type": "pre", language?: string | null, } | { "type": "blockquote", expandable?: boolean, } | { "type": "text_link", url: string, } | { "type": "url" } | { "type": "mention", user_id: number, });

export type FileKind = "photo" | "video" | "voice" | "video_message" | "file" | "sticker" | UnknownString;

export type Attachment = {
/**
 * sha256 hex of the bytes — also the storage key and the cache key (D17).
 */
file_id: string, kind: FileKind, mime: string,
/**
 * `av1` | `h264` for video/video_message: lets the receiver decide whether
 * it can play the file *before* pulling 15 MiB (R18).
 */
codec?: string | null, size: number,
/**
 * Mandatory for photo/video/video_message and known before the bytes
 * arrive — without it the feed jumps while images load (§6.3).
 */
width?: number | null, height?: number | null, duration_ms?: number | null,
/**
 * The light weight of the picture, itself a blob (D233): a photo's
 * 128 px thumbnail, drawn while `file_id` — the preview — is still
 * arriving; a video's poster, which carries the preview weight
 * because there is no larger still behind it.
 */
thumb_file_id?: string | null,
/**
 * Voice notes: 100 buckets of 5 bits, packed then base64 (standard
 * alphabet, padded — the gateway's validator accepts `+/=`).
 */
waveform?: string | null, file_name?: string | null, spoiler?: boolean,
/**
 * The pack a [`FileKind::Sticker`] came out of, and its emoji
 * (docs/stickers-plan.md D550): what a click on it opens, and what the
 * chat list says of it. Absent on every other kind.
 */
sticker?: StickerRef | null, };

export type StickerRef = { pack_id: number,
/**
 * The sticker's first emoji, the whole of a preview line about it
 * (D573). Empty only on a row a newer gateway wrote without one.
 */
emoji: string, };

export type AttachmentInput = { file_id: string, thumb_file_id?: string | null, waveform?: string | null, file_name?: string | null, codec?: string | null, spoiler?: boolean, };

export type Service = { "kind": "call" } & CallLog | { "kind": "joined", by?: number | null, } | { "kind": "left" } | { "kind": "removed", user_id: number, } | { "kind": "admin_granted", user_id: number, } | { "kind": "admin_revoked", user_id: number, } | { "kind": "renamed", name: string, } | { "kind": "banned", user_id: number, until_ms?: number | null, } | { "kind": "unbanned", user_id: number, } | { "kind": "returned", admin?: boolean, } | { "kind": "voice_muted", user_id: number, until_ms?: number | null, } | { "kind": "voice_unmuted", user_id: number, } | { "kind": "owner_changed", user_id: number, } | { "kind": "perk_gift",
/**
 * `perk`, not `kind`: the tag already spells `kind`.
 */
perk: PerkKind, days?: number | null, } | { "kind": "floats_code", code_id: number, amount: number, valid_until_ms?: number | null, };

export type CallLog = {
/**
 * Everyone who was in the call at any point, in the order they arrived.
 * Deliberately not the live roster: the widget outlives the call and has
 * to answer "who was on it", and somebody who hung up early was still on
 * it. This is what the client's "participants" menu shows.
 */
participants: Array<number>,
/**
 * True while the call is running. A widget left `live` by a gateway that
 * restarted mid-call is cleared on the next startup
 * (`MessageStore::end_dangling_calls`), because nothing else ever could:
 * live rooms do not survive the process.
 */
live?: boolean,
/**
 * Wall-clock length, written when the call ends. Absent while it runs,
 * and absent for ever on one a restart interrupted — the gateway knows
 * the call is over but not when it stopped, and inventing a number would
 * put a wrong duration in the history permanently.
 */
duration_s?: number | null, end_reason?: CallEndReason | null, };

export type CallEndReason = "empty" | "alone_timeout" | "channel_deleted" | UnknownString;

export type Call = { channel_id: number,
/**
 * Who started it — the participant that walked into the empty room.
 */
started_by: number,
/**
 * Unix millis, so a client that connects mid-call can show a duration.
 */
started_at_ms: number,
/**
 * Everyone currently in the call, ascending. Also the roster the sidebar
 * draws for channels the reader is *not* in — the voice socket only ever
 * tells participants who else is there.
 */
participants: Array<number>, };

export type Message = { channel_id: number,
/**
 * Monotonic inside the channel; the pagination cursor (D16).
 */
seq: number,
/**
 * The channel's revision at which this message last changed
 * (offline-first-plan.md D318): its send, an edit, a reaction set or
 * cleared, its clock starting, a call widget moving. Numbered by the
 * same counter row as `seq`, so revisions become visible in order, and
 * `GET /v1/channels/{id}/changes?since=` answers everything past one.
 * `0` on a row written before revisions existed and on everything an
 * older gateway serves — a number a device never treats as «next».
 */
rev: number, sender_id: number, sent_at_ms: number, edited_at_ms?: number | null,
/**
 * Client-side UUID: idempotent send and echo de-duplication.
 */
nonce: string, reply_to_seq?: number | null,
/**
 * The message `reply_to_seq` answers, as it stands when this one is
 * served (D273): the gateway reads it for every reply it hands out — a
 * page, the answer to a send or an edit, a socket frame — so a client
 * draws the header over a reply without holding what it answers. Absent
 * when `reply_to_seq` is, on every message the pet API answers a pet
 * with (pets-plan.md D582), and on everything an older gateway sends.
 * Read leniently: a quote this build cannot read is [`ReplyTo::Unknown`]
 * and costs the reply nothing (chat-api.md §7).
 */
reply_to?: ReplyTo | null,
/**
 * Who wrote these words first, on a forwarded message (forwarding.md
 * D374, chat-api.md §1.1b): the gateway writes it from the message it
 * copied, and no client can say it. Absent on everything its sender
 * wrote themselves and on everything an older gateway serves. Read
 * leniently: a header this build cannot read is a [`Forwarded`] with no
 * author — the message still says it is not its sender's own words —
 * and costs the message nothing (chat-api.md §7).
 */
forwarded?: Forwarded | null,
/**
 * Also the caption when attachments are present.
 */
text: string,
/**
 * Lenient by construction: [`crate::text::EntityKind`] carries
 * `#[serde(other)] Unknown`, so a `type` this build cannot name parses to
 * a value rather than an error. A reader that must not silently accept
 * one — a server-to-server import, a replication path — says so itself
 * with [`crate::text::reject_unknown`]; the gateway's storage layer
 * already does (chat-api.md §7).
 */
entities?: Array<Entity>, attachments?: Array<Attachment>,
/**
 * The sender closed the card this message's link would get
 * (link-previews.md D289), so no reader's client draws one. The card
 * itself never travels (D278); this is the one fact about it that does,
 * because only the sender can say they did not want it. Absent on
 * everything an older client sent and everything an older gateway
 * serves — both mean «draw it», which is what they always did.
 */
no_link_preview?: boolean,
/**
 * The lifetime its sender gave it, in seconds (disappearing-messages.md
 * D296, D302). Present from the moment it is sent, whether or not the
 * clock has started; absent on a message that stays, which is every
 * message an older client sent, everything an older gateway serves, and
 * everything the server wrote itself.
 */
ttl_s?: number | null,
/**
 * When this message goes — Unix milliseconds on the **gateway's** clock,
 * which is the one that deletes it (D297).
 *
 * Absent until the clock starts, and the clock starts when somebody other
 * than the author has read it (D302): a lifetime is time to read a
 * message in, and a message nobody has opened has not begun to be read.
 * So a message with [`Self::ttl_s`] and no deadline is waiting for its
 * first reader; one with both is counting; one with neither stays. An
 * edit never sets or moves it.
 */
expires_at_ms?: number | null,
/**
 * Present on the messages the *server* wrote (D71): the call widget and
 * the membership notices. Absent on everything a person typed, so a
 * client that has never heard of them renders the ordinary empty bubble
 * instead of breaking.
 */
service?: Service | null,
/**
 * Spoken in a broadcast channel's name (docs/broadcast-channels-plan.md
 * D841, D848): every post, and a comment its writer sent as the channel.
 * Such a message carries `sender_id` 0 to everybody — no account has
 * that id — and is drawn under the channel's face and name. Absent on
 * everything a person said as themselves.
 */
as_channel?: boolean,
/**
 * The person behind a message in the channel's name (D842) — served to
 * the channel's staff, its owner and server administrators alone, and
 * absent for everybody else.
 */
posted_by?: number | null,
/**
 * Who last edited a post (D850), served by `posted_by`'s rule.
 */
edited_by?: number | null,
/**
 * A post's comments (D846): the channel its thread is, which the
 * comments' pages, sends and reactions go to. Absent on everything that
 * is not a post.
 */
thread_id?: number | null,
/**
 * The post a comment is under (D846): absent on everything that is not a
 * comment.
 */
thread_of?: ThreadOf | null,
/**
 * The post takes no new comments (D851); those already written stay
 * readable. Absent when it does.
 */
comments_off?: boolean,
/**
 * The post takes no new reactions (D851); the chips stay. Absent when it
 * does.
 */
reactions_off?: boolean, };

export type ThreadOf = { channel_id: number, seq: number, };

export type ReplyTo = { "state": "live" } & ReplyQuote | { "state": "deleted" };

export type ReplyQuote = {
/**
 * Who wrote it — a name the client resolves like any other `sender_id`.
 */
sender_id: number,
/**
 * The start of its text: at most [`QUOTE_UNITS`] UTF-16 units, never
 * cut through a surrogate pair, and all of it when it is shorter.
 */
text?: string,
/**
 * The spoilers over [`Self::text`], cut where it is cut (D343), and no
 * other entity: a line that dropped them would say what the message
 * hides. Absent from an older gateway, whose quote is all plain.
 */
entities?: Array<Entity>,
/**
 * Its attachments, whole — what the quote of an album counts and the
 * quote of a file names.
 */
attachments?: Array<Attachment>,
/**
 * Present when the server wrote it (§1.4): the quote then says what
 * kind of notice it was, in the reader's language.
 */
service?: Service | null,
/**
 * It was said in a broadcast channel's name (D841, D842): `sender_id`
 * is 0 and the line names the channel — to every reader, the staff
 * included, because a quote is one line and not a byline.
 */
as_channel?: boolean, };

export type Forwarded = {
/**
 * Who wrote it — a name and a face the client resolves like any other
 * `sender_id`. `0` on a header this build could not read (chat-api.md
 * §7), which still says the words are passed on, and on a channel's
 * words, which [`Self::channel`] names (D860).
 */
sender_id: number,
/**
 * When they wrote it: the original's `sent_at_ms`, on the gateway's
 * clock — not the moment it was forwarded, which is the copy's own.
 */
sent_at_ms: number,
/**
 * The broadcast channel whose words these are (D860): a post, or a
 * comment in the channel's name — read when the copy is served, while
 * the channel is public, so the line shows it as it is now. Absent on a
 * person's words.
 */
channel?: ForwardChannel | null,
/**
 * The words are a channel's that is private now, or gone (D860): the
 * line says «from a private channel», and nothing of the channel travels.
 */
private_channel?: boolean, };

export type ForwardChannel = { id: number, name: string,
/**
 * Its public handle (D870), when it has one.
 */
handle?: string | null, avatar_file_id?: string | null,
/**
 * Verified by the operator (D857).
 */
verified?: boolean, };

export type ForwardSource = { channel_id: number, seq: number, };

export type ReactionGroup = {
/**
 * Always the canonical form [`crate::emoji::canonical`] returned — the
 * store never holds anything else (D152).
 */
emoji: string,
/**
 * Exact, however many the list below shows: `count == users.len()` is the
 * client's own signal that the list is complete.
 */
count: number,
/**
 * At most [`MAX_REACTORS_LISTED`] reactor ids, oldest first — what the
 * chip's avatar row draws. A capped prefix, so the caller may be the
 * twentieth reactor and still absent from it (which is why `my_reactions`
 * exists).
 */
users: Array<number>, };

export type SeqReactions = { seq: number,
/**
 * Always the canonical form [`crate::emoji::canonical`] returned — the
 * store never holds anything else (D152).
 */
emoji: string,
/**
 * Exact, however many the list below shows: `count == users.len()` is the
 * client's own signal that the list is complete.
 */
count: number,
/**
 * At most [`MAX_REACTORS_LISTED`] reactor ids, oldest first — what the
 * chip's avatar row draws. A capped prefix, so the caller may be the
 * twentieth reactor and still absent from it (which is why `my_reactions`
 * exists).
 */
users: Array<number>, };

export type MyReaction = { seq: number, emoji: string, };

export type ReactionsAnswer = { reactions: Array<ReactionGroup>,
/**
 * Absent means cleared — the same omit-the-null convention as §1.
 */
my_reaction?: string | null, };

export type FriendEntry = { user_id: number, channel_id: number, };

export type IncomingRequest = { user_id: number, requested_at_ms: number, };

export type FriendsSnapshot = { friends: Array<FriendEntry>,
/**
 * Visible only. A hidden row is not "an old request" to its recipient —
 * it is nothing at all, and that is the whole of D171.
 */
incoming: Array<IncomingRequest>,
/**
 * Every request this account sent that has not been answered or cancelled,
 * **hidden rows included and indistinguishable** (D171/D172): the sender
 * can never tell a decline, a block or plain silence apart.
 */
outgoing: Array<number>, blocked: Array<number>,
/**
 * `crate::account::FRIEND_POLICIES`; an **open** string rather than an
 * enum so the set can grow without a migration (D173) — a value this
 * build has never heard of is rendered as itself.
 */
policy: string, };

export type Relation = "none" | "outgoing" | "incoming" | "friends" | "self" | UnknownString;

export type Friendship = { relation: Relation,
/**
 * Whether a request would be accepted — computed from the *target's*
 * policy and deliberately ignoring blocks (D172/D176), so that a blocked
 * caller reads exactly what anybody else reads.
 */
can_request: boolean,
/**
 * When this person was last visibly around, for a **friend** who is not
 * visible right now (D193). Omitted — never `null` — in every other case,
 * because there is nothing for a client to tell apart: not a friend,
 * visible right now, never seen, and a gateway that predates the column
 * all draw the same nothing.
 */
last_seen_ms?: number | null, };

export type MembershipChange = "joined" | "left" | "role" | UnknownString;

export type ChannelSettings = {
/**
 * D114. Invisible to non-members; history and media closed.
 *
 * The whole of the access state since D295: `has_password` stood beside
 * it until channels stopped having passwords, and the key is gone from
 * the wire rather than pinned to `false` — every client that ever read it
 * read it through a `serde` default, so its absence is the `false` it
 * always meant.
 */
is_private: boolean, max_voice_ms: number, max_media_bytes: number, max_message_chars: number,
/**
 * Seconds between one person's messages; `0` is off.
 */
slowmode_s: number,
/**
 * Voice for the whole channel (D126). `true` from a gateway that has never
 * heard of the switch, which is what it did.
 */
voice_enabled: boolean,
/**
 * The admin's one switch against a rainbow (D137): everybody's bubbles
 * take the channel's scheme, personal colours included.
 */
channel_scheme_only: boolean,
/**
 * The bubble accent as a hex pair (D136).
 */
accent_light?: string | null, accent_dark?: string | null,
/**
 * The background slots (D134/D168): either half may stand alone, and the
 * theme with no picture of its own wears the other's — see
 * [`ChannelSettings::background`].
 */
bg_light_file_id?: string | null, bg_dark_file_id?: string | null,
/**
 * 0..=100 each, applied as a CSS filter to the background element and
 * never to the feed above it (D135).
 */
bg_blur: number, bg_brightness: number,
/**
 * Whether a new post is born with its comments on.
 */
comments_default: boolean,
/**
 * Whether a new post is born with its reactions on.
 */
reactions_default: boolean,
/**
 * Whether comments take reactions.
 */
comment_reactions: boolean,
/**
 * What a comment may carry besides words: of `sticker`, `voice`,
 * `video_note`, `media`, `file` and `link` (`crate::broadcast::Ability`),
 * all of them by default. Open on the way in: a word this build cannot
 * name is kept and sent back untouched.
 */
comment_allows: Array<string>, };

export type ChannelState = { channel_id: number,
/**
 * Who owns the channel (D109). On every row rather than only on the one
 * the reader has open: the sidebar is where "my channels" is decided, and
 * an owner has to know which of them they can never simply leave. `0`
 * from a gateway that predates owners.
 */
owner_id: number,
/**
 * What kind of channel this is (D168): `standard`, `dm` for a direct
 * conversation, or `group` for one that is private from birth and for
 * good (D274). Omitted when it is the ordinary kind, exactly as `call`
 * and `description` are — absent has to stay cheap, and absent reads as
 * `standard` both for a client that has never heard of the field and for
 * one that has.
 */
kind?: string,
/**
 * The **other** member of a DM (D169), so a client can draw their face
 * rather than the channel's initials. Absent on every other kind.
 */
peer_id?: number | null,
/**
 * The reader stopped the pet this dialog is with (pets-plan.md D368):
 * nothing they write reaches it, the pet may not write here, and the
 * composer is one Restart button that sends `/restart`. Present only
 * then — absent on every other row and from a gateway without pets. The
 * `pet_stopped` frame keeps it current between two reads of the state.
 */
pet_stopped?: boolean,
/**
 * For a DM this is built per viewer and holds the *peer's* resolved name
 * (D169) — `channels.name` is stored empty, because a DM has no one name.
 */
name: string,
/**
 * What the channel is for (D74) — the channel profile's "about". Rides
 * along with the row rather than waiting for a screen to ask for it: it is
 * one short string per channel, and the alternative is a round trip every
 * time somebody opens the profile of a channel they are already reading.
 */
description?: string | null,
/**
 * The channel's photo (D74), as the same `file_id` an avatar is.
 */
avatar_file_id?: string | null,
/**
 * Unix seconds of the channel's creation (D73) — what the client hashes
 * with the name for the circle beside the row. Nothing in the sidebar
 * prints it; the channel's card does, as «Дата создания»
 * (broadcast-channels-plan.md D1003).
 */
created_at: number, max_seq: number,
/**
 * The channel's revision when this answer was read (D318): the last
 * number its counter handed out, which is where a device's `changes`
 * cursor stands once it has everything. Compared with the stored
 * cursor, it says whether anything moved while the device was away;
 * below the stored cursor, it says the gateway went back (§5.5). `0`
 * from a gateway that predates revisions — `server_epoch` on the
 * envelope is the probe for that, not this field.
 */
rev: number, last_read_seq: number, unread: number,
/**
 * How far anybody **other than the reader** has read here (chat-plan.md
 * D422): the furthest of their read marks. A message of the reader's own
 * at or below it has been read by somebody, and is drawn with two checks
 * (D423); above it, with one. The [`ServerEvent::Seen`] frame moves it
 * up between two reads of the state, and nothing moves it down. Absent
 * at `0` — nobody has read anything — which is also how a gateway older
 * than the field reads.
 */
seen_seq?: number,
/**
 * How far the reader deleted this chat for themselves (friends-plan.md
 * D465): every message at or below it is gone from their view — no page,
 * count, preview or search they are served holds one — while the other
 * side keeps all of it. The row itself stays in their list, emptied: the
 * chat is cleared, not gone. Absent at `0` — never deleted — which is
 * also how a gateway older than the field reads.
 */
cleared_seq?: number,
/**
 * Whether the reader is a member of this channel (D72). This is not about
 * seeing it — it is what decides whether the composer or the "join"
 * button is drawn. On a direct row it is `false` for one reason only: the
 * friendship ended and the conversation stays, read-only, on All alone
 * (friends-plan.md D411) — there is nothing to join, and «Delete chat» is
 * what such a row offers (D412).
 */
member: boolean,
/**
 * Whether the reader administers *this channel* — a different thing from
 * `users.is_admin`, which administers the server and outranks it.
 */
admin: boolean,
/**
 * How many people are in the channel.
 */
members: number,
/**
 * The door, for **everybody who can see the row** — not only for
 * members, unlike the settings object below (D141). This is not a hole in
 * D114: a private channel is still absent from this list for anybody who
 * is not in it, so `is_private` is only ever `true` on a row whose reader
 * is already inside.
 */
is_private: boolean,
/**
 * Newest non-deleted message, for the sidebar preview.
 */
last_message?: Message | null,
/**
 * The chips on `last_message`. Reactions never ride on a [`Message`]
 * (reactions-plan.md D147), so the row carries them beside it — and they
 * are the *real* ones, because a hardcoded empty list would read as
 * "nobody reacted", which is a silent lie. No `my_reactions` here: the
 * sidebar draws no chips.
 */
reactions?: Array<ReactionGroup>,
/**
 * The call in progress, if any. Absent is the ordinary case. This is how
 * a client that starts up (or reconnects) mid-call learns about one:
 * `call_started` is an event, and the socket replays nothing.
 */
call?: Call | null,
/**
 * The channel's settings, whole, and only for members (D141). Laziness is
 * a storage detail and must not leak into JSON: a missing *key* would make
 * every client re-implement the defaults, and they would drift. A
 * non-member reads a public channel in the ordinary appearance.
 */
settings?: ChannelSettings | null,
/**
 * A public broadcast channel's handle (docs/broadcast-channels-plan.md
 * D870): `/c/<handle>` opens it and `@handle` names it. Absent when it has
 * none — every other kind, and a private channel.
 */
handle?: string | null,
/**
 * The operator verified it as official (D857): the mark after its name.
 */
verified?: boolean,
/**
 * The reader's staff rights in this broadcast channel (D844), as
 * `crate::broadcast::StaffRight` spells them — kept as words, so one this
 * build cannot name survives the owner's next edit of the set. Absent for
 * everybody not on its staff, and on every other kind.
 */
rights?: Array<string>,
/**
 * What the reader may not do in this broadcast channel, and until when
 * (D853). Absent when nothing is taken.
 */
restricted?: Restriction | null,
/**
 * A hash of this row as served (docs/fast-start.md D1054): what a client
 * says back in `known=` to be spared the row while it has not changed.
 * Opaque, and comparable only with another digest of the same row.
 * Absent at `0`, which is no digest: `GET /v1/state` serves none.
 */
digest?: number, };

export type Restriction = {
/**
 * Of `comment`, `react`, `sticker`, `voice`, `video_note`, `media`,
 * `file` and `link` (`crate::broadcast::Ability`).
 */
abilities: Array<string>,
/**
 * Until when; absent is for ever, as a ban's.
 */
until_ms?: number | null, };

export type ChannelSummary = { channel_id: number,
/**
 * Who owns it (D109). On the profile rather than only in the settings
 * object, because the channel card is where a reader finds out whose room
 * this is, and it is drawn for everybody — the settings screen is not.
 */
owner_id: number, name: string, description: string | null, avatar_file_id: string | null,
/**
 * The door (D114), public like the rest of the profile. `false` from a
 * gateway that predates it — which is what its channels were.
 */
is_private: boolean,
/**
 * A public broadcast channel's handle (docs/broadcast-channels-plan.md
 * D870), absent when it has none.
 */
handle?: string | null,
/**
 * Verified by the operator (D857).
 */
verified?: boolean, };

export type ChannelMember = { user_id: number,
/**
 * Administers this channel.
 */
admin: boolean, joined_at_ms: number,
/**
 * Their microphone is shut for the channel (D125), as of the answer —
 * so the roster says who is muted and offers the way back
 * (channel-admin-plan.md D493). A mute already run out reads as none.
 */
voice_muted?: boolean,
/**
 * Until when, while `voice_muted`; absent is for ever, as everywhere.
 */
voice_muted_until_ms?: number | null,
/**
 * A broadcast channel's staff member's rights (D844), as words. Absent
 * on everybody else's row.
 */
rights?: Array<string>,
/**
 * What is taken from them in a broadcast channel, and until when (D853),
 * as the roster's answer reads it — so the sheet offers «Lift
 * restrictions» to the people who have some.
 */
restricted?: Restriction | null, };

export type MembersResponse = { members: Array<ChannelMember>,
/**
 * Everybody in the channel, however few `?limit=` let through
 * (channel-admin-plan.md D491): the settings screen asks for five faces
 * and still says how many there are.
 */
total: number, };

export type ChannelBan = { user_id: number, banned_by: number,
/**
 * Absent means for ever, on the way in exactly as on the way out.
 */
until_ms?: number | null, banned_at_ms: number, };

export type BansResponse = { bans: Array<ChannelBan>,
/**
 * Everybody barred, however few `?limit=` let through (D491).
 */
total: number, };

export type Invite = { token: string, expires_at_ms: number, };

export type Joined = { admin: boolean, };

export type LinkPreview = {
/**
 * `og:site_name`, or the host the page answered from (without a leading
 * `www.`) when it names none — the line a card opens with.
 */
site_name?: string, title?: string, description?: string,
/**
 * The page's picture, fetched and checked by the gateway, if it had one
 * worth drawing.
 */
image?: LinkImage | null, };

export type LinkImage = {
/**
 * sha256 of the bytes, lowercase hex — the same shape a `file_id` has, and
 * for the same reason: the address *is* the content, so it never goes
 * stale and a client may keep it for as long as it likes.
 */
id: string, width: number, height: number, };

export type ChannelCard = { channel_id: number,
/**
 * `standard`, `dm` or `group` (D168, D274); omitted for the ordinary
 * kind, as on [`ChannelState`].
 */
kind?: string,
/**
 * For a direct conversation, the *other* member's name (D169) — built per
 * viewer, like the sidebar row.
 */
name: string, description?: string | null, avatar_file_id?: string | null,
/**
 * How many people are in it.
 */
members: number,
/**
 * Whether the reader is one of them — the card's button hangs on this.
 */
member: boolean, is_private: boolean,
/**
 * A public broadcast channel's handle (docs/broadcast-channels-plan.md
 * D870), absent when it has none.
 */
handle?: string | null,
/**
 * Verified by the operator (D857).
 */
verified?: boolean,
/**
 * Unix seconds of the channel's creation, as on [`ChannelState`] — the
 * card's «Дата создания» for a channel read before subscribing
 * (broadcast-channels-plan.md D1003). Absent at `0`, which is also how
 * a gateway older than the field reads.
 */
created_at?: number, };

export type BroadcastsResponse = { channels: Array<ChannelCard>, };

export type NewBroadcast = { name: string,
/**
 * Absent is public (D837).
 */
is_private?: boolean,
/**
 * A public channel may be born with its handle (D870).
 */
handle?: string | null, };

export type RightsBody = { rights: Array<string>, };

export type RestrictBody = { user_id: number, abilities: Array<string>, until_ms?: number | null, };

export type ChannelRestriction = { user_id: number, abilities: Array<string>,
/**
 * Absent is for ever.
 */
until_ms?: number | null, restricted_by: number, restricted_at_ms: number, };

export type RestrictionsResponse = { restrictions: Array<ChannelRestriction>,
/**
 * Everybody restricted, however few `?limit=` let through (D491).
 */
total: number, };

export type PostOptionsBody = { comments?: boolean | null, reactions?: boolean | null, };

export type CommentCount = { seq: number, count: number, };

export type ViewCount = { seq: number, count: number, };

export type ViewsBody = { seqs: Array<number>, };

export type ViewsResponse = { views: Array<ViewCount>, };

export type UserStatus = "online" | "afk" | "dnd" | "offline" | "invisible" | "in_call" | UnknownString;

export type PublicStatus = "online" | "afk" | "dnd" | "offline" | "in_call" | UnknownString;

export type ManualStatus = "dnd" | "invisible" | UnknownString;

export type Game = {
/**
 * The game's name, as the player's client found it — a launcher's name
 * for it, or one the person typed — held to
 * [`crate::account::game_name`] (D676).
 */
name: string,
/**
 * When it started, Unix milliseconds on the **gateway's** clock (D674):
 * a viewer reads it through the difference it keeps from that clock.
 */
started_at_ms: number, };

export type GameReport = {
/**
 * Held to [`crate::account::game_name`] by both ends (D676); an empty
 * name is the same report as no game at all.
 */
name: string,
/**
 * How long the game has been running, by the reporting machine's own
 * clock — at most [`crate::account::MAX_GAME_ELAPSED_MS`].
 */
elapsed_ms: number, };

export type PresenceEntry = { user_id: number,
/**
 * A widened [`PublicStatus`] for everybody, and the true self view —
 * `invisible` included — for the caller's own row.
 */
status: UserStatus,
/**
 * What they are playing (docs/game-activity.md D671) — only on a row
 * that says they are here, so never beside `offline` and never on the
 * caller's own `invisible` row. Absent from a gateway older than games,
 * and from everybody not playing.
 */
game?: Game | null, };

export type UserJson = { user_id: number, username: string, is_admin: boolean,
/**
 * Deliberately no `skip_serializing_if` on the three below (D67): a
 * removed avatar and an absent key must read differently on the wire, or
 * a client cannot tell "cleared" from "nothing changed".
 */
display_name: string | null, bio: string | null, avatar_file_id: string | null,
/**
 * Unix seconds of the registration (D73). The client seeds the initials
 * circle with the name *and* this, so two people who happen to share a
 * display name still get different colours.
 */
created_at: number,
/**
 * The personal bubble pair (D137), drawn on *other people's* screens —
 * that is the whole reason it is server-side and the personal background
 * is not (D139).
 */
bubble_light: string | null, bubble_dark: string | null,
/**
 * The standing status choice (D182), `null` for auto — and no
 * `skip_serializing_if`, for the reason the three above have none. What
 * the picker opens marked.
 */
manual_status: ManualStatus | null,
/**
 * D311: this account has to prove an e-mail address before anything but
 * `GET /v1/me` and `/v1/me/email/start|confirm` opens to it — the
 * gateway answers every other authenticated route and both sockets with
 * 403 until it does. Set by `GET /v1/me` alone, since every other route
 * answering this shape is one such an account cannot reach; `false`
 * from a gateway that does not confirm addresses, and absent (so
 * `false`) from one older than the rule.
 */
must_confirm_email: boolean,
/**
 * `pet` for a pet (pets-plan.md D349), absent for a person — what the
 * admin list shows beside a name. A pet never signs in, so `GET /v1/me`
 * never carries it.
 */
kind?: string,
/**
 * Pets on this server (pets-plan.md D363, §10), set by `GET /v1/me`
 * alone. **The capability probe**: a gateway that knows pets always
 * sends it, and a client that finds it absent hides the Pets tab and
 * every pet control rather than offering what the server cannot do.
 */
pets?: PetAbilities | null,
/**
 * The account's «Send usage statistics» switch, inverted
 * (docs/analytics-plan.md D437): `true` once the person turned it off.
 * Set by `GET /v1/me` and `PATCH /v1/me` alone, and **the capability
 * probe** the way [`Self::pets`] is: a gateway that keeps product
 * statistics always sends it, and a client that finds it absent keeps
 * its switch local, since there is nothing on the server to turn off.
 */
analytics_off?: boolean | null,
/**
 * The account's limits (docs/floats-plan.md D632): the base every
 * account has, raised by the perks it holds. Set by `GET /v1/me` alone,
 * and **the capability probe** the way [`Self::pets`] is: a gateway
 * that knows Floats always sends it, and a client that finds it absent
 * keeps its constants and shows no Floats page.
 */
limits?: Limits | null, };

export type MePatch = {
/**
 * `true` stops product statistics about this account and deletes the
 * per-day rows already kept about it; `false` starts them again.
 */
analytics_off?: boolean | null, };

export type DirectoryEntry = { user_id: number, username: string, display_name: string | null,
/**
 * What this person wrote about themselves — the About section of their
 * profile screen (friends-plan.md §6.3).
 */
bio: string | null, avatar_file_id: string | null,
/**
 * Unix seconds of the registration (D73), the second half of the avatar
 * colour seed.
 */
created_at: number,
/**
 * The personal bubble colour (D137), a light/dark pair. It lives here —
 * and not only on `/v1/me` — because the whole point of the colour is
 * that *other* people's clients paint your messages with it, and the
 * directory is the only thing they hold about you.
 */
bubble_light: string | null, bubble_dark: string | null,
/**
 * `pet` for a pet (pets-plan.md D349), absent for a person. A client
 * older than pets draws a pet as a person: face, name, mentions — which
 * is all it needs to read a conversation with one (§10).
 */
kind?: string,
/**
 * A pet's revision (D353, D360): moves with every change to its card —
 * its commands above all — so a client holding a chat's list of commands
 * knows when to ask for it again. Absent for a person.
 */
pet_rev?: number,
/**
 * The pet has been retired (D365): it answers nobody, search skips it,
 * and its old messages keep it as their author. Absent otherwise.
 */
retired?: boolean,
/**
 * The stand's own pet (docs/official-pet-plan.md D934, D939): the
 * verified mark in place of the paw, a dialog nobody types into (D947),
 * no Stop and no mute (D937). Set by the gateway's start alone, from
 * `pets.official`; absent otherwise.
 */
official?: boolean, };

export type PerkKind = "hd_plus" | "files_plus" | "sticker_slot" | "plus" | UnknownString;

export type StreamClass = "base" | "hd_plus" | UnknownString;

export type Limits = {
/**
 * The largest `kind=file` upload, bytes.
 */
file_max: number,
/**
 * The largest photo, bytes. No perk raises it today: the receiving
 * client decodes a picture whole.
 */
photo_max: number,
/**
 * Attachments per message.
 */
attachments_max: number,
/**
 * Bytes one may upload in a day.
 */
upload_day: number,
/**
 * Own packs one may author, and stickers across them (D633).
 */
sticker_packs: number, stickers: number,
/**
 * The stream class a call allocates for this account (D631).
 */
stream_class: StreamClass,
/**
 * Pets this account may make — `0` unless `[pets] creation` lets it,
 * since bot slots are not sold yet (§7 P6).
 */
pets: number, };

export type PerkOffer = {
/**
 * The key a purchase names — `hd_plus_30d`, `sticker_slot`.
 */
id: string, kind: PerkKind,
/**
 * The pass's term in days; absent for a permanent perk (D633).
 */
days?: number | null, price: number, };

export type FloatsCatalog = {
/**
 * Changes whenever the list does; a purchase that names a price the
 * list no longer carries is refused with the list again (D629).
 */
version: string,
/**
 * Whether anything can be bought right now (`[floats] enabled`, and the
 * reconciliation's pause, §5.12). Reading is never paused.
 */
enabled: boolean, perks: Array<PerkOffer>, base: Limits, };

export type ActivePerk = { id: number, kind: PerkKind, starts_ms: number,
/**
 * Absent for a permanent perk (D633).
 */
ends_ms?: number | null,
/**
 * Who bought it for this person (D634), absent when they bought it
 * themselves.
 */
gift_from?: number | null, };

export type FloatsBalance = { balance: number, perks: Array<ActivePerk>, limits: Limits,
/**
 * Quest rewards accrued and not yet claimed (D653) — the quiet dot.
 */
claimable: number,
/**
 * Codes an administrator sent this person that still wait for
 * «Активировать» (D875).
 */
codes_waiting: number, };

export type BuyPerkBody = {
/**
 * A [`PerkOffer::id`].
 */
perk: string,
/**
 * The price the client displayed; a different current price is a 409
 * carrying the catalog (D629).
 */
price: number,
/**
 * The recipient of a gift (D634), absent for oneself.
 */
for_user?: number | null, };

export type PerkBought = { balance: number, perk: ActivePerk, };

export type PerkGrant = { kind: PerkKind, days?: number | null, };

export type RedeemBody = { code: string, };

export type Redeemed = { balance: number, amount?: number | null, perk?: ActivePerk | null, };

export type SentCode = { id: number, amount?: number | null, perk?: PerkGrant | null, sent_ms: number, valid_until_ms?: number | null, };

export type MyCodes = { codes: Array<SentCode>, };

export type TxnKind = "code" | "gift" | "quest" | "perk" | "adjust" | "burn" | "tip" | "tip_settle" | "tip_return" | "sale" | "refund" | UnknownString;

export type StatementEntry = {
/**
 * The transaction's id, and the cursor `?before=` takes.
 */
id: number,
/**
 * `TX-XXXXX-XXXXX`, what a person quotes about this line (D1100). The
 * same for both sides of a gift.
 */
public_id: string, at_ms: number,
/**
 * Signed from the reader's side: what came in is positive.
 */
amount: number, kind: TxnKind,
/**
 * The other person, when there is one the reader may know of: the
 * giver of a gift, the recipient of one. Never the person behind a
 * channel's post (D842), never an administrator's identity.
 */
counterparty?: number | null,
/**
 * The perk a purchase, a gift or a code bought.
 */
perk?: PerkGrant | null,
/**
 * An administrator's reason, on an adjustment (D875).
 */
reason?: string | null,
/**
 * A code an administrator sent, as against one typed (D877).
 */
sent_by_admin?: boolean,
/**
 * What the transaction was about — `code:42`, `perk:7`; a tip's
 * message (`tip:<channel>:<seq>`) once tips exist.
 */
ref?: string | null, };

export type StatementPage = { entries: Array<StatementEntry>,
/**
 * The cursor of the next page, absent at the end.
 */
next_before?: number | null, };

export type QuestAct = "message" | "react_friend" | "sticker" | "reply_group" | "call_friend_minutes" | "watch_friend_minutes" | "stream_friends_minutes" | "call_three" | "make_sticker" | "add_friend" | "avatar" | "publish_pack" | "make_group" | "stream" | UnknownString;

export type QuestCard = {
/**
 * The catalogue's key (`[[floats.quest]] id`).
 */
id: string, act: QuestAct, goal: number, progress: number, reward: number, done: boolean, };

export type QuestStreak = { days: number, forgiven_used: boolean, };

export type QuestsView = {
/**
 * The Moscow day (D440's day) the daily set is drawn for.
 */
day: number, daily: Array<QuestCard>,
/**
 * What the whole daily set pays on top (§3.11), and whether it did.
 */
daily_bonus: number, daily_done: boolean, weekly: Array<QuestCard>, streak: QuestStreak,
/**
 * Accrued and not yet claimed.
 */
accrued: number,
/**
 * Every achievement, done or not; a done one was paid once.
 */
achievements: Array<QuestCard>, };

export type QuestClaimed = { balance: number, claimed: number, };

export type NewCodeBatch = {
/**
 * What each code grants: Floats, or a perk — one of the two.
 */
amount?: number | null, perk?: PerkGrant | null,
/**
 * 1 to [`MAX_CODES_PER_BATCH`].
 */
count: number,
/**
 * Uses per code, 1 by default; still one per account.
 */
uses: number, valid_until_ms?: number | null, note?: string | null, };

export type IssuedCode = { id: number,
/**
 * `XXXX-XXXX-XXXX`.
 */
code: string, };

export type CodeBatchCreated = { batch_id: number, codes: Array<IssuedCode>, };

export type CodeState = "free" | "sent" | "used" | "expired" | "revoked" | UnknownString;

export type CodeUse = { user_id: number, at_ms: number, };

export type CodeRow = { id: number, state: CodeState, sent_to?: number | null, sent_ms?: number | null, uses: Array<CodeUse>, uses_left: number, revoked_ms?: number | null, };

export type CodeBatchRow = { id: number, amount?: number | null, perk?: PerkGrant | null, uses: number, valid_until_ms?: number | null, note?: string | null, created_by: number, created_ms: number, codes: Array<CodeRow>, };

export type CodeBatches = { batches: Array<CodeBatchRow>, };

export type SendCodeBody = { user_id: number, };

export type AdjustBody = { user_id: number, amount: number, reason: string, };

export type Adjusted = { balance: number, };

export type LaunchGift = { amount: number, paid: number, already: number, };

export type Recon = { ok: boolean,
/**
 * Transactions whose legs do not sum to zero.
 */
unbalanced_txns: number,
/**
 * Accounts whose cached balance differs from their postings.
 */
balances_off: number,
/**
 * Every account added up — zero when the ledger is whole.
 */
sum: number,
/**
 * The escrow account's balance, against the tips held.
 */
escrow: number, held_tips: number, };

export type PetAbilities = { create: boolean, };

export type PetCommand = { name: string,
/**
 * Language tag → text (D351), each at most
 * [`crate::account::MAX_PET_COMMAND_DESCRIPTION`] code points. May be
 * empty; a reader picks through [`crate::lang::pick`].
 */
description: { [key in string]: string }, };

export type PetCard = { pet_id: number,
/**
 * The pet's nickname — its username, what `@` and `/cmd@` address (D350).
 */
username: string,
/**
 * The public name chats draw it by (D406), as a person's `display_name`:
 * absent when the owner gave none, and the nickname is drawn instead.
 */
display_name?: string | null, avatar_file_id: string | null,
/**
 * Unix seconds of the pet's making: the second half of its avatar's
 * colour seed, as for a person (D73).
 */
created_at: number,
/**
 * Language tag → what the pet is for (D351), every language the server
 * speaks present, each at most [`crate::account::MAX_PET_DESCRIPTION`]
 * code points.
 */
description: { [key in string]: string },
/**
 * In display order (D353).
 */
commands: Array<PetCommand>,
/**
 * Who made it and answers for it — the card names them (D362).
 */
owner_id: number,
/**
 * Whether a group's admins may add it (D359).
 */
joinable: boolean,
/**
 * As on [`DirectoryEntry::pet_rev`].
 */
rev: number,
/**
 * As on [`DirectoryEntry::retired`].
 */
retired?: boolean,
/**
 * As on [`DirectoryEntry::official`] (D939). Its `owner_id` is its own
 * id (D935): the card says «Официальный аккаунт сервера» there.
 */
official?: boolean, };

export type PetDraft = {
/**
 * [`crate::account::pet_name`]'s rules.
 */
username: string,
/**
 * The public name (D406), a person's display-name rules; absent or blank
 * is none.
 */
display_name?: string | null,
/**
 * Every language of [`crate::lang::ALL`], none of them blank (D351).
 */
description: { [key in string]: string }, commands: Array<PetCommand>,
/**
 * Absent is `true`: a pet can be added to groups unless its owner says not.
 */
joinable: boolean, };

export type PetPatch = { username?: string | null,
/**
 * The public name (D406). The empty string clears it, as on
 * `PATCH /v1/me/profile` (D65).
 */
display_name?: string | null,
/**
 * The whole map, every language present — it replaces the old one.
 */
description?: { [key in string]: string } | null, joinable?: boolean | null, };

export type PetCommands = { commands: Array<PetCommand>, };

export type PetCreated = { pet: PetCard, token: string, };

export type PetToken = { token: string, };

export type MyPet = { pet: PetCard,
/**
 * When the program last asked for updates, Unix milliseconds. Absent for
 * one that never has.
 */
last_poll_at_ms?: number | null,
/**
 * Updates waiting for it.
 */
queued: number, };

export type PetDm = { channel_id: number, };

export type ChatCommand = { pet_id: number,
/**
 * The pet's revision when the list was read: a directory entry that
 * moves past it says the list is stale.
 */
pet_rev: number, name: string, description: { [key in string]: string }, };

export type Sticker = { pack_id: number,
/**
 * sha256 hex of the TGS or the still picture (D17).
 */
file_id: string,
/**
 * The TGS's poster, frame 0 (D549) — the file itself for a still one.
 */
poster_file_id: string,
/**
 * `application/x-tgsticker`, `image/webp` or `image/png`
 * (`echo_wire::sticker::StickerFormat`); anything else is a kind a newer
 * gateway grew, drawn as the «update EchoFloat» line (D552).
 */
mime: string,
/**
 * The composition's points for a TGS, the picture's pixels for a still
 * one: the aspect a bubble and a grid cell are fitted to.
 */
width: number, height: number,
/**
 * One play of a TGS; absent on a still sticker.
 */
duration_ms?: number | null, size: number,
/**
 * One to eight, each in `echo_wire::emoji::canonical` form (D566).
 */
emoji: Array<string>, };

export type StickerKey = { pack_id: number, file_id: string, };

export type StickerPackStatus = "draft" | "published" | "deleted" | "removed" | UnknownString;

export type StickerPack = { id: number,
/**
 * Who published it — shown on its card (D557).
 */
owner_id: number, title: string, status: StickerPackStatus,
/**
 * How many accounts have it installed.
 */
installs: number,
/**
 * Whether the caller has it installed.
 */
installed: boolean,
/**
 * Its live stickers, in the pack's order.
 */
stickers: Array<Sticker>, };

export type StickerPackSummary = { id: number, owner_id: number, title: string, status: StickerPackStatus, installs: number,
/**
 * Its live stickers.
 */
count: number, installed: boolean,
/**
 * Its first stickers: five on a catalogue row, so a page is one request
 * (D566); the cover alone in the installed list (D560).
 */
preview: Array<Sticker>, };

export type StickerCatalog = { packs: Array<StickerPackSummary>,
/**
 * Where the next page starts, opaque to the client; absent on the last.
 */
cursor?: string | null, };

export type StickerPackList = { packs: Array<StickerPackSummary>, };

export type StickerRecents = { stickers: Array<Sticker>, };

export type StickerSuggestions = { stickers: Array<Sticker>, };

export type StickerPackTitle = { title: string, };

export type NewSticker = {
/**
 * A TGS, or a still WebP or PNG.
 */
file: string,
/**
 * The TGS's poster (D549); absent for a still sticker, which is its own.
 */
poster?: string | null, emoji: Array<string>, };

export type StickerPatch = { emoji?: Array<string> | null,
/**
 * Where in the pack it moves to, counted from zero among the live ones.
 */
position?: number | null, };

export type StickerPackOrder = { pack_ids: Array<number>, };

export type StickerPackReport = { reason: string, comment: string, };

export type StickerPackRemoval = { block_files: boolean, };

export type StateResponse = { channels: Array<ChannelState>,
/**
 * The friend-state twin of the `t: "friends"` event (D174) — the same
 * object, so a startup and a live change go through one writer. Absent
 * from a gateway that predates friends, which reads as "no friends, no
 * requests, everyone may ask" — exactly the world such a stand has.
 */
friends: FriendsSnapshot,
/**
 * Everyone who is not offline, plus the caller's own true row (D182).
 *
 * **This is the capability probe.** A gateway that has presence always
 * sends the key, empty list included; `None` means the server has never
 * heard of it, and the client answers by drawing no dots, offering no
 * picker, and — above all — never sending an `activity` frame it would
 * have no way of knowing was ignored.
 */
presence?: Array<PresenceEntry> | null,
/**
 * What the gateway's clock read when it wrote this answer, Unix
 * milliseconds (disappearing-messages.md D298). A message's
 * `expires_at_ms` is on that clock, and a client has to read it through
 * the difference from its own; a live frame teaches it the difference,
 * but a client that has just started has not heard one yet — and the
 * first thing it does is take in a page of history, where a machine
 * running a minute fast would drop every message with less than a
 * minute left. This is the sample that comes before the first page.
 * Absent from a gateway older than the field, which leaves such a client
 * where it was: assuming the clocks agree until a frame says otherwise.
 */
server_time_ms?: number | null,
/**
 * Which database answered (offline-first-plan.md D318, §5.5): a UUID
 * the gateway's schema minted once and never changes. Channel ids and
 * user ids are numbers a fresh database hands out again, so this is
 * how a device tells «the same server» from «a different database at
 * the same address» and empties what it holds. **Also the capability
 * probe for revisions**: a gateway that numbers changes always sends
 * it, and a client that finds it absent runs the legacy reconnect
 * (chat-api.md §3.3) instead of asking for `changes`.
 */
server_epoch?: string | null, };

export type PageResponse = { messages: Array<Message>,
/**
 * Sibling keys, not fields of a message (D147): reactions never ride on a
 * [`Message`], because `MessageEdited` replaces a message whole and a
 * `reactions` field there would be wiped by every edit echo. Both keys
 * are omitted when empty — and absent from a gateway that predates them,
 * which reads identically.
 */
reactions?: Array<SeqReactions>,
/**
 * Where the *caller* stands (D149) — per-request, never broadcast.
 */
my_reactions?: Array<MyReaction>,
/**
 * How many comments each post of a broadcast channel's page has
 * (docs/broadcast-channels-plan.md D849), beside the posts for the
 * reason the chips are: an edit replaces a message whole. Omitted when
 * empty — every page that is not a channel's feed.
 */
comments?: Array<CommentCount>,
/**
 * How many people have seen each post of a broadcast channel's page
 * (docs/broadcast-channels-plan.md D1082), beside the posts for the
 * comment counts' reason. Omitted when empty — every page that is not a
 * channel's feed, and one whose posts nobody has seen.
 */
views?: Array<ViewCount>,
/**
 * Everybody the page names (docs/fast-start.md D1056): its authors, and
 * whoever they mention, quote or reacted with — so a chat just opened
 * draws names rather than `#123` for a round trip. Omitted when empty.
 */
people?: Array<DirectoryEntry>, };

export type Tombstone = { seq: number, rev: number, };

export type ChangesPage = {
/**
 * The channel's revision when this page was read — where the walk ends.
 */
rev: number,
/**
 * Every change at or below this revision has been answered by now; the
 * next request says `since=upto`. Equal to `rev` on the last page.
 */
upto: number,
/**
 * `upto < rev`: there is another page after this one.
 */
more: boolean,
/**
 * Live messages changed after `since`, ascending by `rev`. Read
 * leniently, one message at a time, as a history page is (§7).
 */
messages: Array<Message>,
/**
 * Messages deleted after `since`, ascending by `rev`.
 */
deleted?: Array<Tombstone>,
/**
 * The chips of `messages`, as a page carries them (D147): every
 * reaction the device holds on those messages is replaced by these.
 */
reactions?: Array<SeqReactions>,
/**
 * Where the caller stands on `messages` (D149) — per request, never
 * broadcast.
 */
my_reactions?: Array<MyReaction>,
/**
 * The caller deleted this chat for themselves after `since`, up to and
 * including this `seq` (friends-plan.md D465, offline-first-plan.md
 * D594): the device lets go of everything it holds at or below it, and
 * nothing at or below it is on this page. Absent at `0` — no such
 * deletion is news to this cursor.
 */
cleared_seq?: number,
/**
 * `since` is a revision the gateway cannot answer from: it lies ahead
 * of the channel's counter (the gateway went back — a restored backup)
 * or below the channel's floor, where tombstones it may have missed were
 * forgotten (offline-first-plan.md D593). The page is empty, and the
 * device forgets what it holds of the channel and starts its copy again
 * (D597).
 */
reset?: boolean,
/**
 * The comment counts of `messages`, as a page carries them (D849): a
 * comment moves its post's revision, so the post comes back here with
 * its count.
 */
comments?: Array<CommentCount>,
/**
 * The view counts of `messages`, as a page carries them (D1082). A view
 * moves no revision, so this says nothing of the posts not on this page.
 */
views?: Array<ViewCount>, };

export type BootstrapResponse = {
/**
 * The account, as `GET /v1/me` answers it.
 */
me: UserJson,
/**
 * Every chat on the reader's list, in the sidebar's order, each as
 * `[channel_id, digest]`: which chats exist, and which rows a client
 * holds are current, without being sent any of them (D1053, D1059).
 */
chats: Array<[number, number]>,
/**
 * The first `limit` rows of `chats`, less those `known=` said the client
 * holds as they are (D1054).
 */
rows?: Array<ChannelState>,
/**
 * Everybody `rows` names, the account itself, the official pet and whoever
 * is asking to be a friend (D1056).
 */
people?: Array<DirectoryEntry>,
/**
 * As on [`StateResponse::friends`].
 */
friends: FriendsSnapshot,
/**
 * As on [`StateResponse::presence`].
 */
presence?: Array<PresenceEntry> | null,
/**
 * As on [`StateResponse::server_time_ms`].
 */
server_time_ms?: number | null,
/**
 * As on [`StateResponse::server_epoch`].
 */
server_epoch?: string | null, };

export type ChatRowsResponse = { rows: Array<ChannelState>,
/**
 * Everybody those rows name (D1056).
 */
people?: Array<DirectoryEntry>, };

export type ChatLatest = { channel_id: number,
/**
 * The newest messages: the request named no revision for this chat.
 */
page?: PageResponse | null,
/**
 * What changed after the revision the request named, as one page of
 * `changes` (chat-api.md §2.9). `more` hands the chat to the ordinary pull.
 */
changes?: ChangesPage | null, };

export type LatestResponse = {
/**
 * The chats asked for that the reader may read. One they may not is
 * absent, as one that does not exist is (D114), and so is one past what
 * an answer holds (docs/fast-start.md D1085): an ask by revision absent
 * from here goes on to the ordinary pull.
 */
chats: Array<ChatLatest>,
/**
 * Everybody those messages name (D1056), once however many chats do.
 */
people?: Array<DirectoryEntry>, };

export type MediaResponse = {
/**
 * Photographs and films in the channel's live messages, counted as
 * attachments: an album of four is four.
 */
total: number,
/**
 * How many of them come before this page — the position, from the oldest,
 * of the page's first item, which is what «3» in «3 of 37» is counted
 * from.
 */
before: number,
/**
 * Ascending by `seq`, each with all of its attachments; the reader keeps
 * the visual ones.
 */
messages: Array<Message>, };

export type SearchResponse = {
/**
 * Newest first, from any of the caller's chats — each says which in its
 * own `channel_id`. Served whole, as a page serves them, without chips.
 */
messages: Array<Message>,
/**
 * More messages match than these: the answer stopped at its limit.
 */
more: boolean, };

export type MessageReads = { reads: Array<MessageRead>, };

export type MessageRead = { user_id: number,
/**
 * The minute their read mark first reached the message, as Unix
 * milliseconds on the gateway's clock — a whole minute, because that is
 * all the gateway keeps. Absent for a mark that got there before the
 * gateway kept the time (migration 0043).
 */
read_at_ms?: number | null, };

export type Expiring = { seq: number,
/**
 * Unix milliseconds on the gateway's clock, as [`Message::expires_at_ms`].
 */
expires_at_ms: number,
/**
 * The revision the arming took (D318) — one per message, because each
 * deadline is its own change to its own row. `0` from a gateway older
 * than revisions.
 */
rev: number, };

export type AuthFailure = "expired" | "invalid" | "revoked" | "account_gone" | "email_unconfirmed" | UnknownString;

export type SecurityNoticeKind = "signin" | UnknownString;

export type NoticeSignin = { id: string, device_name?: string | null, device_system?: string | null,
/**
 * `X-Echo-Client` as the login sent it: `desktop/0.13.40`, `web/…`.
 */
client?: string | null, };

export type ServerEvent = { "t": "ready", user_id: number, } | { "t": "message" } & Message | { "t": "message_edited" } & Message | { "t": "message_deleted", channel_id: number, seq: number,
/**
 * The revision the deletion took (D318): what the tombstone in
 * `changes` would carry, so a device that heard the frame moves
 * its cursor over it. `0` from a gateway older than revisions.
 */
rev: number, } | { "t": "message_expiring", channel_id: number, messages: Array<Expiring>, } | { "t": "reaction", channel_id: number, seq: number,
/**
 * Who acted. Also how a client knows a chip is its own on this path
 * (D149): the event names the actor, and the client compares it with
 * itself — nothing per-viewer ever rides a broadcast.
 */
user_id: number,
/**
 * The message's author, on the frame rather than looked up locally
 * (D159): the recipient may not have that message loaded, or that
 * channel open — and the message that scrolled away hours ago is
 * exactly the one a toast matters for.
 */
author_id: number,
/**
 * What `user_id` now has set; `null` means the reaction was cleared.
 * Deliberately no `skip_serializing_if`: an absent key and a cleared
 * reaction must not read the same on the wire.
 */
emoji: string | null,
/**
 * The **whole** summary, not a delta — `CallParticipants`' own
 * reasoning verbatim: the socket replays nothing, so a client that
 * missed one event must not be left counting.
 */
reactions: Array<ReactionGroup>,
/**
 * The message's revision after this change (D318): a reaction
 * moves no `seq`, which is exactly why `?after=` could never heal
 * a chip — and why the revision has to ride here. `0` from a
 * gateway older than revisions.
 */
rev: number, } | { "t": "comments", channel_id: number, seq: number, count: number, rev: number, } | { "t": "typing", channel_id: number, user_id: number, } | { "t": "read", channel_id: number, user_id: number, last_read_seq: number, } | { "t": "seen", channel_id: number, seq: number,
/**
 * Where the reader's mark stood before it moved to `seq`: the
 * messages in `(after, seq]` have a reader they did not have, and no
 * others do — what a client that keeps the readers of a message
 * (D423) lets go of, to ask again the next time it is opened. `0`
 * from a gateway older than the field, which reads as «all of them».
 */
after: number, } | { "t": "channel_created", channel_id: number,
/**
 * For a DM this is the *recipient's* peer, so the row appears named
 * after the right person on each of the two sockets it reaches — which
 * is why acceptance sends this event per viewer and never broadcasts
 * it (D169).
 */
name: string,
/**
 * As on [`ChannelState`] (D168), and omitted for the ordinary kind.
 */
kind?: string, peer_id?: number | null,
/**
 * As on [`ChannelState`] (D73): the row the sidebar inserts on this
 * event has to draw its circle straight away, and the next `state`
 * round trip is a user action away.
 */
created_at: number,
/**
 * Who made it — and therefore the one person already in it, running
 * it (D72). The row a client inserts on this event is otherwise a
 * channel with nobody in it, which is wrong for everybody and wrong
 * in a way the creator can see: their own client offered them a
 * "Join" button for a channel they were already in.
 */
created_by: number, } | { "t": "channel_deleted", channel_id: number, } | { "t": "dm_ended", channel_id: number, } | { "t": "history_cleared", channel_id: number, through_seq: number, rev: number, } | { "t": "channel_renamed", channel_id: number,
/**
 * Carried because handing the channel over (D112) broadcasts this same
 * event: a client that only re-read the name would go on drawing the
 * old owner's settings row until the next `GET /v1/state`.
 */
owner_id: number, name: string,
/**
 * As on [`ChannelState`] (D168). A DM's rename event is the one a
 * *display name* change fans out — per viewer, one frame each, so an
 * old client never holds a stale peer name until its next resync.
 */
kind?: string, peer_id?: number | null, description: string | null, avatar_file_id: string | null,
/**
 * The door, as on [`ChannelState`] — public to everybody who may see
 * the channel at all. The settings event carries the same fact to the
 * members; this is how the lock reaches the rest of the stand, which
 * is the audience that has to know what a channel's door is like
 * *before* trying to open it.
 */
is_private: boolean,
/**
 * A public broadcast channel's handle (docs/broadcast-channels-plan.md
 * D870) — whole-profile like everything here, so absent is «none».
 */
handle?: string | null,
/**
 * Verified by the operator (D857).
 */
verified?: boolean, } | { "t": "channel_settings", channel_id: number, settings: ChannelSettings, } | { "t": "membership", channel_id: number, user_id: number, change: MembershipChange,
/**
 * Whether they administer the channel now. Always false once they are
 * gone.
 */
admin: boolean,
/**
 * Their staff rights in a broadcast channel now
 * (docs/broadcast-channels-plan.md D844), as words; absent when they
 * hold none. In a broadcast channel this frame reaches its staff and
 * the person it is about, never its subscribers (D838).
 */
rights?: Array<string>, } | { "t": "restricted", channel_id: number, user_id: number, abilities: Array<string>, until_ms?: number | null, } | { "t": "profile_updated", user_id: number, username: string, display_name: string | null,
/**
 * `default` for a gateway that predates the screen: absent reads as
 * "no bio", which is what such a gateway would have meant anyway.
 */
bio: string | null, avatar_file_id: string | null,
/**
 * Registration date, unchanged by definition (D73) — it is here
 * because the event is a whole directory entry, not a delta.
 */
created_at: number,
/**
 * The personal bubble pair (D137), whole-entry like everything else
 * here: `null` means "no colour", and a client that rebuilds the row
 * from the event must not be left guessing whether the pair moved.
 */
bubble_light: string | null, bubble_dark: string | null,
/**
 * As on [`DirectoryEntry`] (pets-plan.md D349): a pet's card moving
 * is broadcast like a person's profile, and a client that rebuilt
 * the entry without these would turn the pet back into a person.
 */
kind?: string, pet_rev?: number, retired?: boolean,
/**
 * As on [`DirectoryEntry::official`] (docs/official-pet-plan.md
 * D939): the official pet's card moving is broadcast like any pet's,
 * and an entry rebuilt without it would lose the mark.
 */
official?: boolean, } | { "t": "call_started" } & Call | { "t": "call_participants" } & Call | { "t": "call_ended", channel_id: number, reason: CallEndReason, } | { "t": "call_declined", channel_id: number,
/**
 * The decliner.
 */
user_id: number, } | { "t": "friends" } & FriendsSnapshot | { "t": "presence", user_id: number, status: PublicStatus,
/**
 * What they are playing, beside any status but `offline` (D671).
 * Absent when they are not playing — and from a gateway older than
 * games, which reads the same.
 */
game?: Game | null, } | { "t": "presence_sync", presence: Array<PresenceEntry>, } | { "t": "my_presence", status: UserStatus, manual: ManualStatus | null, } | { "t": "pet_stopped", channel_id: number, stopped: boolean, } | { "t": "floats", balance: number, code?: SentCode | null, } | { "t": "perks", perks: Array<ActivePerk>, limits: Limits, } | { "t": "quests", accrued: number, completed: Array<string>, } | { "t": "security_notice", kind: SecurityNoticeKind,
/**
 * The new sign-in, as its line on the sessions list describes it —
 * for `signin`, always.
 */
signin?: NoticeSignin | null,
/**
 * When, on the gateway's clock, in Unix milliseconds.
 */
at_ms: number, } | { "t": "error", message: string,
/**
 * Why the auth frame was refused, when it was (offline-first-plan.md
 * D316): the same word a 401 carries, so a device decides the same
 * thing about its saved sign-in whichever door refused it. Absent
 * on every other error frame, one before `ready` included: the
 * socket's ten seconds ran out, or the database could not be asked.
 * That says nothing about the token, and a device keeps its sign-in
 * and dials again (docs/admission.md D1076).
 */
reason?: AuthFailure | null, };

export type ClientEvent = { "t": "auth", jwt: string, } | { "t": "typing", channel_id: number, } | { "t": "activity", idle: boolean, } | { "t": "playing", game: GameReport | null, } | { "t": "pong" };

export type SendBody = { nonce: string, text: string, entities: Array<Entity>, attachments: Array<AttachmentInput>, reply_to_seq?: number | null,
/**
 * [`Message::no_link_preview`] (D289). A gateway older than it ignores
 * the field, and the message gets its card.
 */
no_link_preview?: boolean,
/**
 * How long the message is to live, in seconds from the moment the
 * gateway stores it (disappearing-messages.md D296):
 * [`crate::account::MIN_MESSAGE_TTL_S`]`..=`[`crate::account::MAX_MESSAGE_TTL_S`],
 * and anything else is a 400 rather than a clamp. Absent — the message
 * stays. A gateway older than the field ignores it and the message stays
 * too, which its answer says by carrying no `expires_at_ms`: the one way
 * a sender's client can tell, and it must.
 */
ttl_s?: number | null,
/**
 * The message this send forwards, instead of saying anything of its own
 * (forwarding.md D374): the gateway copies its words, formatting and
 * attachments into this channel and writes [`Message::forwarded`]
 * itself. `text`, `entities`, `attachments` and `reply_to_seq` stay
 * empty beside it; `ttl_s` may be said, and is the copy's own. A gateway
 * older than the field ignores it and refuses the empty message that is
 * left with a 400 — which is how a client learns it cannot forward
 * there, and nothing is made.
 */
forward?: ForwardSource | null,
/**
 * The sticker this send is, instead of words of its own
 * (docs/stickers-plan.md D550): the gateway reads the pack's row and
 * writes the one [`FileKind::Sticker`] attachment itself. `text`,
 * `entities`, `attachments` and `forward` stay empty beside it;
 * `reply_to_seq` and `ttl_s` may be said. A gateway older than the field
 * ignores it and refuses the empty message left with a 400, and nothing
 * is made.
 */
sticker?: StickerKey | null,
/**
 * A comment written in the broadcast channel's name
 * (docs/broadcast-channels-plan.md D848) — `comment_as_channel`'s holders
 * alone. In a channel's own feed every post is, and this is not asked.
 */
as_channel?: boolean,
/**
 * A post born with its comments on or off (D851); absent takes the
 * channel's `comments_default` (D852). Anywhere but a channel's feed it
 * means nothing.
 */
comments?: boolean | null,
/**
 * The same for its reactions.
 */
reactions?: boolean | null, };

export type EditBody = { text: string, entities: Array<Entity>,
/**
 * [`Message::no_link_preview`] as the edited message is to have it
 * (D289): an edit replaces the words whole, and whether their link gets
 * a card is said again with them. Absent leaves it as it was — an edit
 * from a client older than the field, made to a message sent from a
 * newer one, must not bring back a card its author closed.
 */
no_link_preview?: boolean | null, };

/** Every `t` this build understands; an unknown one is logged and skipped (§3.1). */
export const SERVER_EVENT_TAGS = ["ready", "message", "message_edited", "message_deleted", "message_expiring", "reaction", "comments", "typing", "read", "seen", "channel_created", "channel_deleted", "dm_ended", "history_cleared", "channel_renamed", "channel_settings", "membership", "restricted", "profile_updated", "call_started", "call_participants", "call_ended", "call_declined", "friends", "presence", "presence_sync", "my_presence", "pet_stopped", "floats", "perks", "quests", "security_notice", "error"] as const;

/** Every `service.kind` this build can word; an unknown one renders as a visible notice. */
export const SERVICE_KINDS = ["call", "joined", "left", "removed", "admin_granted", "admin_revoked", "renamed", "banned", "unbanned", "returned", "voice_muted", "voice_unmuted", "owner_changed", "perk_gift", "floats_code"] as const;

/** Every entity `type` this build can draw; an unknown one styles nothing and is dropped on the way out. */
export const ENTITY_TYPES = ["bold", "italic", "underline", "strike", "spoiler", "code", "pre", "blockquote", "text_link", "url", "mention"] as const;

